var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14216 11.4317C4.14216 8.97749 4.82963 7.18624 6.00819 6.00767C7.18674 4.82911 8.97799 4.14164 11.4322 4.14164C13.8863 4.14164 15.6776 4.82911 16.8561 6.00767C18.0347 7.18624 18.7221 8.97749 18.7221 11.4317C18.7221 13.8858 18.0347 15.6771 16.8561 16.8557C15.6776 18.0343 13.8863 18.7217 11.4322 18.7217C8.97799 18.7217 7.18674 18.0343 6.00819 16.8557C4.82963 15.6771 4.14216 13.8858 4.14216 11.4317ZM11.4322 2.35592C8.64929 2.35592 6.3491 3.14137 4.7455 4.74499C3.14189 6.3486 2.35645 8.6488 2.35645 11.4317C2.35645 14.2145 3.14189 16.5147 4.7455 18.1183C6.3491 19.722 8.64929 20.5074 11.4322 20.5074C13.6997 20.5074 15.6467 19.9859 17.1576 18.9253L19.5104 21.278C19.9986 21.7661 20.79 21.7661 21.2781 21.2779C21.7663 20.7897 21.7663 19.9983 21.2781 19.5101L18.9254 17.1576C19.9863 15.6466 20.5079 13.6994 20.5079 11.4317C20.5079 8.6488 19.7224 6.3486 18.1189 4.74499C16.5151 3.14137 14.215 2.35592 11.4322 2.35592Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ff40ff5f.svg";
export { ForwardRef as ReactComponent };